export default {
  namespaced: true,
  layout_builder: {
    title: 'Layouts',
    action_add: 'Criar layout',
    action_update: 'Atualizar layout',
    fields: {
      name: {
        label: 'Nome do Layout',
        placeholder: 'Nome do Layout'
      },
      tenant: {
        label: 'Tenant',
        placeholder: 'Tenant'
      },
      users: {
        label: 'Usuários',
        placeholder: 'Usuários'
      },
      default: {
        label: 'padrão',
      },
      card: {
        label: 'Cartão',
      },
      card_distance: {
        label: 'Distância',
      },
      update_current: {
        label: 'Atualizar layout',
      },
      create_new_layout: {
        label: 'Criar novo layout',
      },
      dashboard_mode: {
        label: 'Modo dashboard',
      },
    },
    btns: {
      add_slot: 'Adicionar espaço',
      save: 'Salvar',
    },
    strings: {
      optional: 'Opcional',
    },
    messages: {
      no_blank_spaces: 'Não pode haver espaço em branco',
      no_enough_space: 'Não há espaço suficiente para um novo item',
      created_success: 'Layout criado com sucesso',
      updated_success: 'Layout atualizado com sucesso',
      new_layout_created: 'Novo layout criado com sucesso',
    },
    is_default: 'Por padrão',
    preview: 'Visualização',
  }
}
